import { gql } from "@apollo/client"
import {
  DISTRIBUTION_CENTER_DETAIL_FRAG,
  DISTRIBUTION_CENTER_LIST_FRAG,
  STORAGE_LOCATION_FRAG,
} from "./distribution-center.fragments.gql"

export const DISTRIBUTION_CENTERS_LIST = gql`
  query DistributionCentersList(
    $query: String
    $first: Int
    $skip: Int
    $filter: DistributionCentreLocationInput
  ) {
    allDistributionCentres(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      ...DistributionCenterListFrag
    }
  }
  ${DISTRIBUTION_CENTER_LIST_FRAG}
`

export const DISTRIBUTION_CENTERS_DETAIL = gql`
  query DistributionCentersDetail($id: ID!) {
    distributionCentreLocationDetail(id: $id) {
      id
      geometry {
        type
        coordinates
      }
      properties {
        ...DistributionCenterDetailFrag
      }
    }
  }
  ${DISTRIBUTION_CENTER_DETAIL_FRAG}
`
export const PEOPLE_SELECTOR = gql`
  query allPeopleSelector(
    $group: String
    $first: Int
    $skip: Int
    $query: String
    $departmentId: ID
  ) {
    usersByGroup(
      groupName: $group
      first: $first
      skip: $skip
      query: $query
      departmentId: $departmentId
    ) {
      id
      fullName
      number
    }
  }
`

export const DC_LOCATIONS = gql`
  query AllDCLocations($pocId: ID) {
    allDistributionCentreLocations(filter: { pointOfContacts: $pocId }) {
      id
      properties {
        name
        colorCode
        address {
          id
          latitude
          longitude
          village
        }
      }
      geometry {
        type
        coordinates
      }
    }
  }
`

export const DC_STORAGE_LOCATIONS = gql`
  query DCStorageLocations(
    $first: Int
    $skip: Int
    $filter: DCSubLocationInput
  ) {
    allDcStorageLocations(first: $first, skip: $skip, filter: $filter) {
      ...StorageLocationFrag
    }
  }
  ${STORAGE_LOCATION_FRAG}
`

export const DC_STOCK_TAKE_CONFIGS = gql`
  query DCStockTakeConfigs($filter: DCStockTakeConfigFilterInput) {
    allDcStockTakeConfigs(filter: $filter) {
      id
      distributionCentre {
        id
        name
      }
      startDay
      endDay
      startTime
      endTime
      itemCategory
    }
  }
`
